import React from "react";
import classNames from "classnames";

import CustomSection from "../../custom-general/custom-section";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import { PAUTScanPlanItem } from "../pautScanPlanItems";
import { Column } from "../../../../utils/models";
import { formatTime } from "../../../../utils/utilities";
import { APP_DATE_FORMAT } from "../../../../utils/constants";

import styles from './style.module.scss';

interface Props {
    pautScanItems: PAUTScanPlanItem[];
}

const CustomPAUTPlan: React.FC<Props> = ({ pautScanItems}) => {
    return ( 
        <>
            {pautScanItems.map((pautItem) => (
                <CustomSection key={pautItem.id} sectionTitle="Scan Plan">
                    <div className={classNames(["p-1", styles.summary])}>
                        <PDFTablePage 
                            data={[pautItem]} 
                            columns={FIRST_TABLE} 
                        />

                        <div className="mt-1">
                            <PDFTablePage 
                                data={[pautItem]} 
                                columns={SECOND_TABLE} 
                            />
                        </div>
                       
                        <div className="mt-1">
                            <PDFTablePage 
                                data={[pautItem]} 
                                columns={THIRD_TABLE} 
                            />
                        </div>
                        
                        <div className="mt-1">
                            <PDFTablePage 
                                data={[pautItem]} 
                                columns={FOURTH_TABLE} 
                            />
                        </div>

                        <div className={classNames(["p-1", styles.summaryImage])}>
                            <img src={pautItem.images[0].src} alt={pautItem.images[0].caption} />
                        </div>
                    </div>
                </CustomSection>
            ))}
        </>
     );
};

const FIRST_TABLE: Column[] = [
    {
        path: 'wallThickness',
        label: 'WALL THICKNESS (mm)',
    },
    {
        path: 'bevelAngle',
        label: 'BEVEL ANGLE',
    },
    {
        path: 'weldBevelShape',
        label: 'WELD BEVEL SHAPE',
    },
    {
        path: 'weldCondition',
        label: 'WELD CONDITION',
    },
    {
        path: 'scanType',
        label: 'SCAN TYPE',
    },
];

const SECOND_TABLE: Column[]  = [
    {
        path: 'materialType',
        label: 'TYPE OF MATERIAL',
    },
    {
        path: 'arrayType',
        label: 'TYPE OF ARRAY',
    },
    {
        path: 'calibrationBlockThickness',
        label: 'CALIBRATION BLOCK THICKNESS (mm)',
    },
    {
        path: 'probeSerialNumber',
        label: 'PROBE SERIAL NUMBER',
    },
    {
        path: 'wedgeSerialNumber',
        label: 'WEDGE SERIAL NUMBER',
    },
];

const THIRD_TABLE: Column[] = [
    {
        path: 'inspectionDate',
        label: 'INSPECTION DATE',
        content: (item) => <span>{formatTime(item.inspectionDate, APP_DATE_FORMAT)}</span>
    },
    {
        path: 'numberOfElementsUsed',
        label: 'NUMBER OF ELEMENTS USED',
    },
    {
        path: 'scanSide',
        label: 'SCAN SIDE',
    },
    {
        path: 'scanDirection',
        label: 'SCAN DIRECTION',
    },
    {
        path: 'waveType',
        label: 'WAVE TYPE',
    },
];
 
const FOURTH_TABLE: Column[] = [
    {
        path: 'equipmentModal',
        label: 'EQUIPMENT MODAL',
    },
    {
        path: 'equipmentSerialNumber',
        label: 'EQUIPMENT SERIAL NUMBER',
    },
    {
        path: 'equipmentCalibrationDate',
        label: 'EQUIPMENT CALIBRATION DUE DATE',
        content: (item) => <span>{formatTime(item.equipmentCalibrationDueDate, APP_DATE_FORMAT)}</span>
    },
    {
        path: 'referenceDB',
        label: 'REFERENCE dB',
    },
    {
        path: 'scanAngle',
        label: 'SCAN ANGLE (deg)',
    },
];
 
export default CustomPAUTPlan;